import { render, staticRenderFns } from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_h5.vue?vue&type=template&id=9300b776&scoped=true&"
import script from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_h5.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_h5.vue?vue&type=script&lang=js&"
import style0 from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_h5.vue?vue&type=style&index=0&id=9300b776&scoped=true&lang=less&"
import style1 from "./cordx-tyfast-ovulation-test-pregnancy-test-combo_h5.vue?vue&type=style&index=1&id=9300b776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9300b776",
  null
  
)

export default component.exports